const config = {
    apiKey: "AIzaSyAJt2KC0MsGVjO_NHQ5Tne1jnYxwE051Hk",
    authDomain: "ant-elo-pe.firebaseapp.com",
    projectId: "ant-elo-pe",
    storageBucket: "ant-elo-pe.appspot.com",
    messagingSenderId: "565124740259",
    appId: "1:565124740259:web:ded67713795ae0b5283b16",
    measurementId: "G-2BC78KMDS8"
}

export default config;